import React, { useState } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import "../styles/active.css"

const AmenitiesCarousel = ({ amenities }) => {

  const [currentTab, setCurrentTab] = useState({
    tab: amenities[0].tab,
    image: amenities[0].image,
    description: amenities[0].description,
    activeIndex: 0
  });

  const TabChangeHandler = (id) => {
    setCurrentTab({
      tab: amenities[id].tab,
      image: amenities[id].image,
      description: amenities[id].description,
      activeIndex: id
    })
  };

  return (
    <>
      <Wrapper>
        <TabContainer>
          {amenities.map((amenity, i) => {
          const isActive = currentTab.activeIndex === i ? 'active' : 'menu'
          return (
          <Tab className={isActive} key={i}  onClick={() => TabChangeHandler(amenity.id)}>{amenity.tab}</Tab>)})}
        </TabContainer>
        <InfoContainer backgroundImage={currentTab.image}>
          <ContentWrapper>
            <ContentContainer>
              <Title>{currentTab.tab}</Title>
              <Description>{currentTab.description}</Description>
            </ContentContainer>
          </ContentWrapper>
        </InfoContainer>
      </Wrapper>
    </>
  );
}


AmenitiesCarousel.propTypes = {
  amenities: PropTypes.array.isRequired,
};

// ********** Styled Components ********** //


const Wrapper = styled.div`

  // Margin & Padding
  margin: 0 auto;
  padding: 0;
  
  max-width: 90vw;
  
  border-radius: 3px;
  overflow: hidden;
  
  background-color: var(--primaryWhite);
  
  box-shadow: 0 0 2px rgba(0,0,0,.15),0 1px 2px rgba(0,0,0,.15);
  
  
  // Flexbox
  display: flex;
  flex-direction: column;
  align-items: center;
  
  height: 100%; // TODO remove
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    max-width: 100vw;
  }
`;

const TabContainer = styled.div`
  
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  //grid-gap: 1em;
  
  //margin-bottom: 1em;

  
  
  
  align-items: center;
  // Sizing
  width: 100%;
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;


const InfoContainer = styled.div`
  
  // Positioning
  position: relative;

  // Sizing
  width: 100%;
  height: 70vh; // TODO remove
  
  // Colors
  background-color: transparent;
  
  overflow: hidden;
  
  background-image: url(${props=>props.backgroundImage});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  // Large phones and below
  @media only screen and (max-width : 544px) {
    height: 45vh;
  }
  
  // Border
  //border-radius: 3px;
`;


let Tab = styled.button`
  
  // Margin & Padding
  margin: 0;
  padding: var(--spacer-3) 0; // TODO Check
  -webkit-tap-highlight-color: transparent;
  


  // Sizing
  width: 100%;
  
  // Font
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: 500;
  font-size: var(--font-4);
  text-transform: uppercase;
  line-height: 1.25;
  
  
  
  // Color
  background-color:  var(--primaryWhite);
  color: var(--textBlack);
  
  // Border
  border: none; 
  //border-bottom: 3px solid var(--primaryRed);
  
  //border-radius: 3px;
  
  // Others
  cursor: pointer;
  
  // Transition
  transition: all .3s ease;
  
  // Large phones and below
  @media only screen and (max-width : 414px) {
    font-size: var(--font-3);
  }
   
  &:hover, &:active {
    color: var(--textWhite);
    background-color: var(--primaryRedHover);
  };


`;


const BackgroundImage = styled.div`
  
  // Margin & Padding
  margin: 0;
  padding: 0;
  
  // Positioning
  position: absolute;
  
  // Sizing
  width: 100%;
  height: 70vh;
  
  // Background
 
  
  // Border
  border: none;
  border-radius: 0;
  
  // Others
  z-index: 1;
`;


const ContentWrapper = styled.div`
  
  // Margin & Padding
  margin: 0;
  //padding: 1em 2em;
  
  position: absolute;
  bottom: 0;
  left: 0;
  
  
  // Sizing
  height: 100%;
  width: 100%;
  
 display: flex;
 
 flex-direction: column;
 justify-content: flex-end;
 
 z-index: 3;
  
  
  
  // Border
  border-radius: 3px;
  
  // Large phones and below
  @media only screen and (max-width : 414px) {
    //padding: 1em 1em;
  }
`;

//  - Created on July 9, 2020
const ContentContainer = styled.div`
  
  // Spacing
  margin: 0;
  padding: var(--spacer-3) var(--spacer-4);
  
  // Color
  background-color: rgba(255,255,255,0.60);
  
  
  width: 100%;
  
  

  
  
  // Large phones and below
  @media only screen and (max-width : 414px) {
    padding: var(--spacer-3) var(--spacer-3);
  }
  
    
`;


const Title = styled.h2`

  // Margin & Padding
  margin: 0 0 0 0;
  padding: 0 0 0 var(--spacer-2);
  
  // Display
  display: inline-block;
    
  // Font
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: 500;
  font-size: var(--font-4);
  //text-transform: uppercase;
  line-height: 1.5;
  
  border-left: 3px solid var(--primaryRed);
  
  // Color
  color: var(--textBlack);
  
  // Border
  //border-bottom: 3px solid var(--primaryRed);
  
  // Large phones and below
  @media only screen and (max-width : 414px) {
    font-size: var(--font-4);
  }
`;


const Description = styled.p`
  
  // Margin & Padding
  margin: 0;
  padding: 0 0 0 var(--spacer-2);

  
  // Font
  font-family: var(--bodyFont);
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-3);
  line-height: 1.25;
  
  text-overflow: ellipsis;
  overflow: hidden;
  
  // Colors
  color: var(--textBlack);
  
  border-left: 3px solid var(--primaryRed);
  
  @media only screen and (max-width : 414px) {
    font-size: var(--font-2);
  }
`;

export default AmenitiesCarousel
